import { ConfigureSSOActions } from '@modules/workspaceSettings/components/SSOSettings/ConfigureSSOActions';
import { useFetchTenantSSOSettings } from '@modules/workspaceSettings/hooks';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { Chip, Stack, Typography } from '@mui/material';

export const ConfigureSSO = () => {
  const { ssoSettings } = useFetchTenantSSOSettings();
  const isSSOEnabled = ssoSettings?.isEnabled;

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" spacing={4} alignItems="center">
        <Stack spacing={1}>
          <Typography variant="body1">Configure SSO</Typography>
          <Typography variant="body2" color="text.secondary">
            Use Single Sign-on for your organization
          </Typography>
        </Stack>
        {ssoSettings !== undefined && (
          <Chip
            icon={
              isSSOEnabled ? (
                <CheckCircleRoundedIcon color="success" />
              ) : undefined
            }
            label={isSSOEnabled ? 'Configured' : 'Not Configured'}
            color={isSSOEnabled ? 'success' : 'default'}
          />
        )}
      </Stack>
      <ConfigureSSOActions />
    </Stack>
  );
};
